export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
